<template>
    <popup-modal ref="popup">
        <h2 style="margin-top: 0">{{ title }}</h2>
        <p>{{ message }}</p>
        <div class="btns">           
            <v-btn
                @click="_cancel"
                color="error">
                            {{ cancelButton }}
            </v-btn>            
            <v-btn
                @click="_confirm"
                color="primary">
                            {{ okButton }}
            </v-btn>             
        </div>
    </popup-modal>
</template>

<script>
    import PopupModal from './PopupModal';

    export default {
        name: 'ConfirmDialogue',

        components: { PopupModal },

        data: () => ({
            // Parameters that change depending on the type of dialogue
            title: undefined,
            message: undefined,
            okButton: undefined,
            cancelButton: 'Cancelar',
            resolvePromise: undefined,
            rejectPromise: undefined,
        }),

        methods: {
            show(opts = {}) {
                this.title = opts.title;
                this.message = opts.message;
                this.okButton = opts.okButton;
                if (opts.cancelButton) {
                    this.cancelButton = opts.cancelButton;
                }
                // Once we set our config, we tell the popup modal to open
                this.$refs.popup.open();
                // Return promise so the caller can get results
                return new Promise((resolve, reject) => {
                    this.resolvePromise = resolve;
                    this.rejectPromise = reject;
                });
            },

            _confirm() {
                this.$refs.popup.close();
                this.resolvePromise(true);
            },

            _cancel() {
                this.$refs.popup.close();
                this.resolvePromise(false);
                // Or you can throw an error
                // this.rejectPromise(new Error('User cancelled the dialogue'))
            },
        },
    };
</script>

<style scoped>
    .btns {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }    
</style>


// WEBPACK FOOTER //
// src/components/shared/ConfirmDialogue.vue